import React, { useState } from 'react';

const StoreContext = React.createContext([{}, () => { }]);

const StoreProvider = ({ children }) => {
    const [storedata, setStoredata] = useState({
        cercaValues: [], //usata dalle zone
        //coda messaggi gestita tramite useStoreMsg
        msgs: [],
        //eventhandler
        eventi: {}, //code in base a un parametro quindi object in radice
        eventiNextId: 1,
        //dati stato tabelle
        tabledatas: [],
        tabledatas2: [],
        //permessi applicati
        permessi: {},
    });
    return (
        <StoreContext.Provider value={[storedata, setStoredata]}>
            {children}
        </StoreContext.Provider>
    );
}

export { StoreContext, StoreProvider };